import { useTheme } from "@/context/ThemeContext";

export const NovaBrand = ({ className = "w-full" }) => {
  const { theme } = useTheme();
  const src = theme === "dark" ? "/nova-logo-lockup-dark.png" : "/nova-logo-lockup-white.png";
  return (
    <img
      src={src}
      alt="Nova Opsis - A New Way Forward"
      className={`h-auto object-contain ${className}`}
      data-testid="nova-brand-logo"
    />
  );
};
